import store from '../../../store/sellsyaccountmanager/cart';

export default {
    created() {
        // Init store
        this.$store.registerModule('cart', store);
    },
}